import AuthSlider from '@/components/auth/AuthSlider';

const Signup = () => <AuthSlider initialMode="signup" />;

export default Signup;
